module.exports = __webpack_public_path__ + "media/images/account-black-bfe01b3b1b7499439b6998da39d35421.svg";